import { observer } from 'mobx-react-lite'
import { Box, Card, Grid, Group, Text, Badge, Skeleton } from '@mantine/core'
import { useStore } from '../../app/stores/store'
import { EmptyState, AmmoScoreBadge, StatCard } from '../../app/common/ui'
import { formatDistanceToNow } from 'date-fns'

export default observer(function ModeratorSummaryTab () {
  const { moderationStore } = useStore()
  const { moderatorSummary, loadingSummary } = moderationStore

  if (loadingSummary && moderatorSummary.length === 0) {
    return (
      <Grid>
        {[1, 2].map((i) => (
          <Grid.Col key={i} span={6}>
            <Skeleton height={180} radius="md" />
          </Grid.Col>
        ))}
      </Grid>
    )
  }

  if (moderatorSummary.length === 0) {
    return (
      <EmptyState
        title="No moderators"
        message="No active moderator roles have been granted."
        action={{ label: 'Grant a role', onClick: () => {} }}
      />
    )
  }

  return (
    <Box>
      <Grid>
        {moderatorSummary.map((mod) => (
          <Grid.Col key={mod.userId} span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder>
              <Group position="apart" mb="xs">
                <Group spacing="xs">
                  <Text weight={600}>@{mod.username}</Text>
                  <AmmoScoreBadge tier={mod.ammoTier} score={mod.ammoScore ?? 0} size="sm" />
                </Group>
                {mod.flagsResolved === 0 && (
                  <Badge color="yellow" size="sm" variant="light">
                    No recent activity
                  </Badge>
                )}
              </Group>
              <Text size="sm" color="dimmed" mb="sm">
                Scope: {mod.scope}
              </Text>
              <Group spacing="md" mb="sm">
                <StatCard label="Flags Resolved" value={mod.flagsResolved} />
                <StatCard label="Avg Hours" value={mod.avgHoursToResolution.toFixed(1)} />
              </Group>
              <Text size="xs" color="dimmed" mb={4}>
                Dismiss: {mod.countDismiss} · Warn: {mod.countWarn} · Remove: {mod.countRemove} · Escalate: {mod.countEscalate}
              </Text>
              <Text size="xs" color="dimmed">
                Last action: {mod.lastActionAt ? formatDistanceToNow(new Date(mod.lastActionAt), { addSuffix: true }) : 'No recent activity'}
              </Text>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
      <Text size="sm" color="dimmed" mt="lg">
        Summary covers the last 30 days. Includes all users with active moderator roles and all admin users.
      </Text>
    </Box>
  )
})
